/* Reviews carousel (PRO system) — sections/cs-reviews-carousel.liquid
   Slides the cards with the shared Embla carousel manager. Arrows are
   disabled at either end. */
if (!customElements.get('cs-reviews-carousel')) {
  customElements.define(
    'cs-reviews-carousel',
    class CsReviewsCarousel extends HTMLElement {
      connectedCallback() {
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.prev?.addEventListener('click', () => this.embla?.scrollPrev());
        this.next?.addEventListener('click', () => this.embla?.scrollNext());

        const start = () => {
          if (!window.emblaCarouselManager) return setTimeout(start, 50);
          window.emblaCarouselManager.loadEmblaScript().then(() => this.init());
        };
        start();
      }

      init() {
        const viewport = this.querySelector('.embla__viewport');
        this.embla = window.emblaCarouselManager.initCarousel(`reviews-${this.dataset.sectionId}`, viewport, {
          align: 'start',
          containScroll: 'trimSnaps',
          slidesToScroll: 1,
        });
        if (!this.embla) return;
        ['init', 'reInit', 'select', 'resize'].forEach((event) => this.embla.on(event, () => this.updateArrows()));
        this.updateArrows();
      }

      updateArrows() {
        const canPrev = this.embla.canScrollPrev();
        const canNext = this.embla.canScrollNext();
        if (this.prev) this.prev.disabled = !canPrev;
        if (this.next) this.next.disabled = !canNext;
        // Hide the arrows when every card already fits
        const arrows = this.querySelector('.cs-reviews__arrows');
        if (arrows) arrows.hidden = !canPrev && !canNext;
      }
    }
  );
}
